<template>
  <textarea
    :id="id"
    :type="type"
    class="text-area"
    wrap="soft"
    :class="[variant, size, isEmpty]"
    :placeholder="placeholder"
    :value="modelValue"
    :tabindex="tabindex"
    :maxlength="maxlength"
    @input="updateValue"
    @change="sendChangeEvent($event)"
    @focus="sendFocusEvent($event)"
    @blur="sendBlurEvent($event)"
    @click="sendClickEvent($event)"
    @mousedown="sendMousedownEvent($event)"
    @mouseover="sendMouseoverEvent($event)"
    @mouseout="sendMouseoutEvent($event)"
    @keydown="sendKeydownEvent($event)"
    @keyup="sendKeyupEvent($event)"
  ></textarea>
</template>

<script>
import {
  sendInputEvent,
  sendFocusEvent,
  sendChangeEvent,
  sendBlurEvent,
  sendClickEvent,
  sendMousedownEvent,
  sendMouseoverEvent,
  sendMouseoutEvent,
  sendKeydownEvent,
  sendKeyupEvent,
} from "@/utils/FormEvent";
export default {
  name: "TextArea",
  props: {
    modelValue: { type: String, default: "" },
    variant: { type: String, default: "" },
    size: { type: String, default: "" },
    id: { type: String, default: "" },
    name: { type: String, default: "", require: true },
    type: { type: String, default: "text" },
    maxlength: { type: Number, default: 500 },
    placeholder: { type: String, default: "" },
    excludeLineCode: { type: String, default: "", require: false },
    tabindex: { type: String, default: "" },
    emptyColor: { type: String, default: "" },
    trackingName: { type: String, default: "" },
  },
  emits: ["update:modelValue", "input", "change"],
  setup() {
    return {
      sendInputEvent,
      sendFocusEvent,
      sendChangeEvent,
      sendBlurEvent,
      sendClickEvent,
      sendMousedownEvent,
      sendMouseoverEvent,
      sendMouseoutEvent,
      sendKeydownEvent,
      sendKeyupEvent,
    };
  },
  computed: {
    isEmpty() {
      return this.emptyColor && this.value.length < 1 ? "-empty" : "";
    },
  },
  methods: {
    updateValue(e) {
      this.sendInputEvent(e);
      if (this.excludeLineCode === "true") {
        e.target.value = e.target.value.replace(/\r?\n/g, "");
      }
      this.$emit("input", e.target.value);
      this.$emit("change", e.target.value);
      this.$emit("update:modelValue", e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.text-area {
  border: 1px solid $secondary;
  padding: 14px 10px;
  line-height: 20px;
  width: 100%;
  font-size: 16px;
  @include mq-up(md) {
    padding: 10px;
  }
  &.-empty {
    background-color: $info;
  }
  &.-lg {
    max-width: 600px;
  }
  &.-md {
    max-width: 350px;
  }
  &.-sm {
    max-width: 180px;
    @include mq-up(md) {
      max-width: 200px;
    }
  }
  &.-xs {
    max-width: 120px;
    @include mq-up(md) {
      max-width: 100px;
    }
  }
}
</style>
